"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptimalWidthGridLayout = void 0;
var Utilities_1 = require("icf-search-client-shared/lib/Utilities");
var FluidGridLayout_1 = require("./FluidGridLayout");
var OptimalWidthGridLayout = /** @class */ (function (_super) {
    __extends(OptimalWidthGridLayout, _super);
    function OptimalWidthGridLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptimalWidthGridLayout.prototype.createLayoutPassContext = function (options, availableSize, itemCount) {
        var availableColumnCounts = options.availableColumnCounts, optimalWidth = options.optimalWidth;
        return _super.prototype.createLayoutPassContext.call(this, __assign(__assign({}, options), { columnCount: (0, Utilities_1.getClosestNumber)(window.innerWidth / optimalWidth, availableColumnCounts) }), availableSize, itemCount);
    };
    return OptimalWidthGridLayout;
}(FluidGridLayout_1.FluidGridLayout));
exports.OptimalWidthGridLayout = OptimalWidthGridLayout;
//# sourceMappingURL=OptimalWidthGridLayout.js.map